<template>
  <div id="Service">
    <div>
      <!-- <Navimg :path="require('@/assets/hhdimg/nav5.jpg')"></Navimg> -->
      <div id="swiper" class="container-fuild">
        <div class="swiper-container banner-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
              <img class="swiper-lazy" :src="item" :alt="$t('home.banner')" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row gutter-0 wap-gutter-10">
        <Typeleft
          :title="$t('home.sulotion')"
          :typelist="typeList"
          :active="String(active)"
          @selectType="selectType"
        ></Typeleft>
        <div id="right" class="col-md-9 col-xs-12">
          <PageHeader :title="name"></PageHeader>
          <!-- <div class="p-2 text-content wow fadeIn" data-wow-delay="0.1s">
            <div v-html="contentstr"></div>
          </div> -->
          <div class="container-fluid container-team py-5">
            <div class="row g-4">
              <div
                class="col-md-4 col-xs-6 wow fadeInUp"
                v-for="(item, index) in list"
                data-wow-delay="0.1s"
                @click="onDetail(item)"
              >
                <div class="product_list">
                  <div class="img">
                    <img class="img-fluid w-100" :src="item.coverUrl" alt="" />
                  </div>
                  <div class="txt">
                    <span class="solutionName">{{ item.solutionName }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="page" v-if="total > 0">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="6"
              @current-change="changeSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { productType, productList } from "@/api/modules/product";
import Swiper from "swiper";
import { homePage } from "@/api/modules/home";
import Typeleft from "@/components/Typeleft.vue";
import PageHeader from "@/components/PageHeader.vue";
import { solutionType, solutiondetail, solutionInfo } from "@/api/modules/solution";
export default {
  name: "Service",
  metaInfo() {
    return {
      title: this.PageTitle,
      meta: [
        {
          name: this.PagekeyWords,
          content: this.PageDescription,
        },
      ],
    };
  },
  components: {
    Typeleft,
    PageHeader,
  },
  data() {
    return {
      active: "",
      list: [],
      total: 0,
      pageNum: 1,
      typeList: [],
      contentstr: "",
      swiperList: [],
      name: this.$t("home.sulotion"),
      PageTitle: "",
      PagekeyWords: "",
      PageDescription: "",
      swperInstance: null,
    };
  },
  watch: {
    "$route.query.id": {
      immediate: true,
      handler(newQuery) {
        if (newQuery) {
          this.active = newQuery;
        }
        this.getSolutionType();
      },
    },
    swiperList: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          // 确保DOM更新完成后，重新初始化Swiper
          if (this.swperInstance) {
            this.swperInstance.destroy();
          }
          /* banner-swiper */
          this.swperInstance = new Swiper(".banner-swiper", {
            loop: true, // 循环模式选项
            effect: "fade",
            //自动播放
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            // 如果需要分页器
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            // 延迟加载
            lazy: {
              loadPrevNext: true,
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
          /* customer-swiper */
          new Swiper(".customer-swiper", {
            loop: true, // 循环模式选项
            slidesPerView: 3,
            //自动播放
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
          /* wowjs动画 */
          var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true,
          });
          wow.init();
        });
      },
    },
  },
  mounted() {
    var wow = new WOW();
    wow.init();
    // if (this.$route.query.id) {
    //   this.active = this.$route.query.id;
    // }
    this.getBannerList();
    // this.getSolutionType();
  },
  methods: {
    onDetail(item) {
      solutionInfo(item.id).then((res) => {
        if (res.returnCode == 200) {
          if (res.data.backdropUrl&&res.data.backdropFirstTitel) {
            this.$router.push({
              path: "/servicedetail",
              query: {
                data: encodeURIComponent(JSON.stringify(item)),
              },
            });
          }else{
            this.$router.push({
              path: "/serviceDetail_old",
              query: {
                data: encodeURIComponent(JSON.stringify(item)),
              },
            });
          }
        }
      });
      // this.$router.push({
      //   path: "/servicedetail",
      //   query: {
      //     data: encodeURIComponent(JSON.stringify(item)),
      //   },
      // });
    },
    getBannerList() {
      let data = {
        page: 1,
        moduleType: 2,
        language: this.$store.getters.lang,
      };

      homePage(data).then((res) => {
        if (res.returnCode == 200 && res.data.length > 0) {
          this.swiperList = res.data[0].bannerUrl.split(";");
          this.PageTitle = res.data[0].seoTitle;
          this.PagekeyWords = res.data[0].seoKeyWord;
          this.PageDescription = res.data[0].seoContent;
          console.log("332092=====wlew", this.swiperList);
        }
      });
    },
    // 获取解决方案分类
    getSolutionType() {
      console.log("349394=klkk", this.$store.getters.lang);
      solutionType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200 && res.data.length > 0) {
          this.typeList = res.data;
          // this.getLevel(res.data)
          // this.active = this.active ? this.active : res.data[0].typeId;
          this.solutionInfo();
        }
      });
    },

    // 获取第一个层级内容
    getLevel(data) {
      if (data[0].children.length > 0) {
        this.getLevel(data[0].children);
      } else {
        this.active = data[0].typeId;
      }
    },

    // 选择解决方案分类
    selectType(e) {
      this.active = e;
      this.total = 0;
      this.pageNum = 1;
      this.solutionInfo();
    },

    // 改变页数
    changeSize(e) {
      this.pageNum = e;
      this.solutionInfo();
    },

    // 获取方案详情
    solutionInfo() {
      let data = {
        pageSize: 6,
        pageNum: this.pageNum,
        language: this.$store.getters.lang,
      };
      if (this.active) {
        data["solutionType"] = Number(this.active);
      }
      console.log("3939=====ggg", this.$store.getters.lang);
      solutiondetail(data).then((res) => {
        if (res.returnCode == 200) {
          this.total = res.pageInfo.totalCount;
          this.list = res.data;
        }
      });
    },

    // onDetail(item){
    //     this.$router.push({
    //         // path: '/products/detail',
    //         path:'/productsdetail',
    //         query: {
    //            data:encodeURIComponent(JSON.stringify(item))
    //         }
    //     })
    //   },
  },
};
</script>
<style scoped>
/* 整体盒子 */
#Service {
  width: 100%;
  background-color: #f7f7f7;
}

#left {
  margin: 20px 0;
}

#right {
  padding: 20px 0;
}

#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#swiper .banner-swiper .swiper-slide {
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}

#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

.img-fluid {
  height: 165px;
}

.solutionName {
  display: inline-block;
  width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media screen and (max-width: 768px) {
  #right {
    padding: 15px;
  }

  #swiper {
    height: 200px;
  }
}

.page {
  width: 100%;
  display: flex;
  justify-content: center;
}

.text-content {
  background-color: #fff;
  margin-top: 20px;
}

.product_list .txt {
  text-align: center;
  display: block;
  /* line-height: 55px; */
  line-height: 36px;
  background: #eee;
  font-size: 16px;
  padding: 0 10px;
  transition: all 0.3s;
}

.product_list .img {
  margin: 0;
  position: relative;
}

.product_list .img::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  top: 0;
  left: 0;
  transition: all 0.3s;
}

.product_list:hover .txt {
  background: #036eb8;
  color: #fff;
}

.product_list:hover .img::before {
  background: rgba(0, 0, 0, 0.5);
}

.product_list .img::after {
  content: "";
  display: block;
  width: 50px;
  height: 50px;
  position: absolute;
  left: calc(50% - 25px);
  top: calc(50% - 25px);
  background: #fff url("../assets/hhdimg/pdsbg.png") no-repeat center;
  border-radius: 100px;
  transform: scale(0);
  transition: all 0.3s;
}

.product_list:hover .img::after {
  transform: scale(1);
}

/deep/ .el-pagination {
  display: flex;
}

/deep/ .el-pager {
  display: flex;
}

/deep/ .el-pagination.is-background .el-pager li {
  width: 40px;
  height: 40px;
  border-radius: 50% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin:0 !important; */
  font-size: 18px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

/deep/ .el-pagination .btn-prev {
  width: 40px;
  height: 40px;
  border-radius: 50% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

/deep/ .el-pagination .btn-next {
  width: 40px;
  height: 40px;
  border-radius: 50% !important;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

/deep/ .el-pagination .btn-next .el-icon {
  font-size: 18px !important;
}

/deep/ .el-pagination .btn-prev .el-icon {
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/Service.vue